import React from 'react';
import { Route, Routes } from 'react-router-dom';
import UserList from './UserList';
import UserCreate from './UserCreate';
import UserEdit from './UserEdit';

const UserRoutes = ({
  context = { type: 'hke' },
  basePath = '/app/users',
  title = 'Users',
  description = 'Manage user accounts and access.',
  scope = 'hke',
  allowGlobalCreate = true,
}) => {
  return (
    <Routes>
      <Route
        path=""
        element={(
          <UserList
            context={context}
            basePath={basePath}
            title={title}
            description={description}
            scope={scope}
            allowGlobalCreate={allowGlobalCreate}
          />
        )}
      />
      {allowGlobalCreate ? (
        <Route path="create" element={<UserCreate basePath={basePath} scope={scope} context={context} />} />
      ) : null}
      <Route path="edit/:id" element={<UserEdit basePath={basePath} scope={scope} context={context} />} />
    </Routes>
  );
};

export default UserRoutes;
